/* eslint-disable max-len */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyle = makeStyles(() => {
    const strokeColor = '#ffffff'; // #9aff54
    const bgColor = '#094D1C';

    return {
        root: {
            '& *': {
                stroke: 'none',
                fill  : 'none',
            },
            '& .fillBackground': {
                fill: `${bgColor}`,
            },
            '& .fill': {
                fill  : `${strokeColor}`,
                stroke: 'none',
            },
            '& .stroke': {
                stroke: `${strokeColor}`,
            },
        },
    };

}, { name: 'GenericSensorModuleIcon' });


interface GenericSensorModuleIconProps {
    readonly className?: string;
}

export const GenericSensorModuleIcon: React.FC<GenericSensorModuleIconProps> = (props: GenericSensorModuleIconProps) => {

    const classes = useStyle();

    return (
        <svg className={clsx(classes.root, props.className)} xmlns="http://www.w3.org/2000/svg" width="43" height="28" viewBox="0 0 43 28">
            <g>
                <rect className="stroke fillBackground" width="38" height="23" x="1.5" y="3.5" strokeWidth="3" rx="2" />
                <rect className="fill" width="9" height="6" x="34" y="12" rx="1" />
                <rect className="fill" width="9" height="6" x="24.5" y="1.5" rx="1" transform="rotate(90 29 4.5)" />
                <rect className="fill" width="7" height="6" x="18.5" y=".5" rx="1" transform="rotate(90 22 3.5)" />
                <path className="fill" d="M2 4h13v2.99c0 .558-.447 1.01-.999 1.01H2V4zM39 26H29v-5.01a1 1 0 0 1 .995-.99H39v6zM2 19h2.99c.558 0 1.01.444 1.01 1v3a1 1 0 0 1-1.01 1H2v-5z" />
                <rect className="fill" width="2" height="12" x="10" y="11" rx="1" />
                <rect className="fill" width="2" height="12" x="14" y="11" rx="1" />
                <path className="fill" d="M18 12.002c0-.553.453-1.002.997-1.002h6.006c.55 0 .997.456.997 1.002v9.996c0 .553-.453 1.002-.997 1.002h-6.006c-.55 0-.997-.456-.997-1.002v-9.996z" />
            </g>
        </svg>
    );
};
